/**
 * Token management via Supabase Auth sessions
 * Supabase gestionează token-urile intern — acest modul oferă un wrapper compatibil
 */

/**
 * Obține header-urile de autentificare din sesiunea Supabase (preferat pe native/web).
 */
export async function getAuthHeadersAsync() {
  try {
    const { supabase } = await import('../lib/supabase');
    const { data: { session } } = await supabase.auth.getSession();
    const accessToken = session?.access_token;
    if (!accessToken) return getAuthHeaders();
    return {
      Authorization: `Bearer ${accessToken}`,
      'X-Auth-Token': accessToken,
    };
  } catch {
    return getAuthHeaders();
  }
}

/**
 * Obține header-urile de autentificare din localStorage (sync fallback).
 */
export function getAuthHeaders() {
  const storageKey = Object.keys(localStorage).find(key =>
    key.startsWith('sb-') && key.endsWith('-auth-token')
  );
  if (!storageKey) return {};
  try {
    const session = JSON.parse(localStorage.getItem(storageKey));
    const accessToken = session?.access_token;
    if (!accessToken) return {};
    return {
      'Authorization': `Bearer ${accessToken}`,
      'X-Auth-Token': accessToken
    };
  } catch {
    return {};
  }
}

export function getAuthToken() {
  const headers = getAuthHeaders();
  return headers['X-Auth-Token'] || null;
}

export function hasValidTokens() {
  const token = getAuthToken();
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return Date.now() < payload.exp * 1000;
  } catch {
    return false;
  }
}

export function saveTokens() {
  // Supabase gestionează intern
}

export async function clearTokens() {
  try {
    const { supabase } = await import('../lib/supabase');
    await supabase.auth.signOut();
  } catch {}
}

export function getTokens() {
  const token = getAuthToken();
  return { authToken: token, authzToken: token };
}

export function getAuthzToken() {
  return getAuthToken();
}

export function isAuthTokenExpired() {
  return !hasValidTokens();
}

export function isAuthzTokenExpired() {
  return !hasValidTokens();
}
